import { useTranslate, useTranslation } from 'module/hooks/use-translation';
import { FC } from 'react';
import {
  AddFilterButton,
  FilterCriteriaWrapper,
  Row,
} from '../components/common';
import { matchTypeLabelAString } from '../components/match-label';
import { Criteria } from '../criteria/criteria';
import { getDefaultCriteria } from '../criteria/get-default-criteria';
import { BaseSimpleFilterComponentProps } from '../types';

export interface Props extends BaseSimpleFilterComponentProps {
  hideMatchTypeText?: boolean;
  addButtonText?: string;
}

export const Filter: FC<Props> = ({
  fields,
  filter,
  onChange,
  getFilterOperationTypeOptions,
  getSelectEditorComponents,
  hideMatchTypeText = false,
  addButtonText,
  getOperationOptionRenderer,
  userOptionsGetter,
  className,
}) => {
  const default_text = useTranslation('task_list.filters.add');
  const add_filter = addButtonText ?? default_text;
  const translate = useTranslate();

  return (
    <div className={className}>
      <FilterCriteriaWrapper className="ssf-advanced-box">
        {filter.criteria.map((f, i) => (
          <Row key={`${f.field.fieldId}_${String(i)}`}>
            <Criteria
              hideMatchTypeText={hideMatchTypeText}
              onRemove={() =>
                onChange({
                  ...filter,
                  criteria: filter.criteria.filter((_, j) => i !== j),
                })
              }
              matchTypeLabel={matchTypeLabelAString(i, filter.type, translate)}
              fields={fields}
              filter={f}
              getFilterOperationTypeOptions={getFilterOperationTypeOptions}
              getSelectEditorComponents={getSelectEditorComponents}
              onChange={(g) =>
                onChange({
                  ...filter,
                  criteria: filter.criteria.map((x, j) => (i !== j ? x : g)),
                })
              }
              getOperationOptionRenderer={getOperationOptionRenderer}
              index={i}
              userOptionsGetter={userOptionsGetter}
            />
          </Row>
        ))}
        {filter.criteria.length === 0 && (
          <Row>
            <Criteria
              hideMatchTypeText={hideMatchTypeText}
              matchTypeLabel={matchTypeLabelAString(
                filter.criteria.length,
                filter.type,
                translate,
              )}
              fields={fields}
              getFilterOperationTypeOptions={getFilterOperationTypeOptions}
              getSelectEditorComponents={getSelectEditorComponents}
              getOperationOptionRenderer={getOperationOptionRenderer}
              onChange={(g) =>
                onChange({ ...filter, criteria: filter.criteria.concat(g) })
              }
              userOptionsGetter={userOptionsGetter}
            />
          </Row>
        )}
      </FilterCriteriaWrapper>
      {filter.criteria.length > 0 && (
        <Row>
          <AddFilterButton
            data-cy="add.filter"
            onClick={() =>
              onChange({
                ...filter,
                criteria: filter.criteria.concat(getDefaultCriteria(fields[0])),
              })
            }
          >
            {add_filter}
          </AddFilterButton>
        </Row>
      )}
    </div>
  );
};
